import { BaseClient } from '@/api'

export class AdWxAppClient extends BaseClient {
  constructor(
  ) {
    super('ad_wxapp')
  }
}
